import Component from '@component';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../configClrzApp';
import Slide from '@core/Slide';

export default class ExpandableMobile extends Component {
	onInit(el) {
		this.onPointerdown = this.onPointerdown.bind(this);

		this.el = el;
		this.btn = this.el.querySelector('.js-expandable-btn');
		this.wrapper = this.el.querySelector('.js-expandable-wrapper');
		this.accountMenu = this.el.querySelector('.js-expandable-account-menu');
		this.isOpen = false;

		if (this.wrapper === null || this.btn === null) {
			this.onDestroy();
			return;
		}

		this.slide = new Slide(this.wrapper);

		this.viewportWidth = null;

		this.focusByTab = false;
	}

	onResize() {
		this.isOpen = false;
	}

	onLoad() {
		if (!this.accountMenu) {
			window.addEventListener('resize', () => {
				if (window.innerWidth < 1080) {
					this.viewportWidth = window.innerWidth;

					if (this.viewportWidth >= 991) {
						this.open();
					} else {
						this.close();
					}

					this.initAttributes();
				} else {
					this.removeAttributes();
				}
			});
		}

		this.isMobile = Device.width < breakpointsApp.desktop;

		if (this.isMobile) {
			if (this.btn !== void 0) {
				this.btn.addEventListener('click', this.onPointerdown);
			} else {
				this.el.addEventListener('click', this.onPointerdown);
			}

			this.style = window.getComputedStyle(this.wrapper);

			this.initAttributes();
		}
	}

	initAttributes() {
		this.btn.setAttribute('aria-expanded', 'false');
		this.btn.setAttribute(
			'aria-controls',
			this.btn.getAttribute('data-aria-controls'),
		);
		this.wrapper.setAttribute(
			'aria-labelledby',
			this.btn.getAttribute('data-aria-labelledby'),
		);

		if (this.style.display !== 'none') {
			this.isOpen = true;
			this.btn.setAttribute('aria-expanded', 'true');
			this.wrapper.setAttribute('tabindex', -1);
			this.wrapper
				.querySelectorAll('a, select, button')
				.forEach((focusableEl) => {
					focusableEl.setAttribute('tabindex', -1);
				});
		} else {
			this.btn.setAttribute('aria-expanded', 'false');
			this.wrapper.removeAttribute('tabindex');
			this.wrapper
				.querySelectorAll('a, select, button')
				.forEach((focusableEl) => {
					focusableEl.removeAttribute('tabindex');
				});
		}
	}

	removeAttributes() {
		this.btn.removeAttribute('aria-expanded');
		this.btn.removeAttribute('aria-controls');
		this.wrapper.removeAttribute('aria-labelledby');
		this.wrapper.removeAttribute('tabindex');
		this.wrapper
			.querySelectorAll('a, select, button')
			.forEach((focusableEl) => {
				focusableEl.removeAttribute('tabindex');
			});
		this.wrapper.style.display = 'block';
		this.wrapper.style.maxHeight = 'none';
	}

	onPointerdown() {
		if (!this.isOpen) {
			this.open();
		} else {
			this.close();
		}
	}

	open() {
		this.wrapper.style.display = 'block';
		this.isOpen = true;
		this.btn.setAttribute('aria-expanded', 'true');
		this.btn.classList.add('is-open');
		this.wrapper.removeAttribute('tabindex');
		this.wrapper
			.querySelectorAll('a, select, button')
			.forEach((focusableEl) => {
				focusableEl.removeAttribute('tabindex');
			});
	}

	close() {
		this.wrapper.style.display = 'none';
		this.isOpen = false;
		this.btn.setAttribute('aria-expanded', 'false');
		this.btn.classList.remove('is-open');
		this.wrapper.setAttribute('tabindex', -1);
		this.wrapper
			.querySelectorAll('a, select, button')
			.forEach((focusableEl) => {
				focusableEl.setAttribute('tabindex', -1);
			});
	}
}
